// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editable-cell {\r\n  position: relative;\r\n}\r\n\r\n.editable-cell-value-wrap {\r\n  padding: 5px 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.editable-row:hover .editable-cell-value-wrap {\r\n  padding: 4px 11px;\r\n  border: 1px solid #d9d9d9;\r\n  border-radius: 2px;\r\n}\r\n\r\n[data-theme=\"dark\"] .editable-row:hover .editable-cell-value-wrap {\r\n  border: 1px solid #434343;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
